// extracted by mini-css-extract-plugin
export default {"cta":"RF-z","disabled":"SF-z"};